import { Avatar, Box, Card, Typography } from "@mui/material";

const RecentLoggedInList = ({ loggedInUsers, onClick }) => {
  console.log("RecentLoggedInList", loggedInUsers);
  return (
    <Box gap={1} display="flex" flexDirection="column">
      {loggedInUsers?.map((item, index) => (
        <Card
          key={index}
          sx={{
            cursor: "pointer",
            boxShadow: 3,
            "&:hover": {
              boxShadow: 6,
            },
            width: "100%",

            display: "flex",
            alignItems: "center",
            padding: 1,
            gap: 1,
          }}
          onClick={() => onClick(item)}
          variant="outlined"
        >
          <Avatar
            sx={{
              width: 50,
              height: 50,
            }}
            src={require(`../../assets/img/profiles/p${index + 6}.jpg`)}
          />{" "}
          <Box>
            <Typography fontSize={14} fontWeight={600}>
              {item.name}
            </Typography>
            <Typography variant="caption">{item.description}</Typography>
            <Typography fontSize={12} color="#333">
              Last Visit: {item.dob}
            </Typography>
          </Box>
        </Card>
      ))}
    </Box>
  );
};

export default RecentLoggedInList;
